<template>
  <div id="app">
   <div class="header-middle siteHeader">
      <!--header-middle-->
      <div class="container">
          <div class="row title-row">
              <div class="col-sm-9">
                  <div class="logo pull-left">
                      <div class="col-sm-3 companylogo">
                          <img src="/static/images/dandm/logo.gif" alt="D&M Books Logo" />
                      </div>
                      <div class="col-sm-9 main-heading">
                          D&M Books
                          <p>D&M Books specialise in buying and selling old and rare children's books, annuals and comics.</p>
                      </div>
                  </div>
              </div>
              <div class="col-sm-3">
                  <div class="shop-menu pull-right">
                      <div class="contactinfo pull-right">
                          <ul class="nav nav-pills">
                              <li><a href="#" class="largePhoneNo"><i class="fa fa-phone"></i> 01924 495768</a></li>
                          </ul>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div><!--/header-middle-->
    <div class="error" v-show="isError">
      <div class="container"><i class="fa fa-exclamation-circle"></i> An error occured loading the page - please try and refresh</div>
    </div>
    <router-view/>
    <div class="overlay" v-show="showLoader">
      <div class="loading-spinner">
        <img src="/static/images/dandm/dualball.gif" />Please wait...
      </div>
    </div>
  <div id="footer" class="footer-bottom">
    <div class="container">
        <div class="row">
            <p class="pull-left">Copyright © {{ new Date().getFullYear() }} D&M Books All rights reserved. </p>
        </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'App',
  created() {
    /* eslint no-unused-vars: ["error", { "args": "none" }] */
    /* eslint no-param-reassign: "error" */
    this.$http.interceptors.response.use(response => response, (err) => {
      const status = err.response ? err.response.status : null;
      if (status === 401) {
        return this.getToken().then((_) => {
          err.config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
          return this.$http.request(err.config);
        });
      }
      return Promise.reject(err);
    });
  },
  methods: {
    getToken() {
      const gotToken = this.$store.dispatch('getToken');
      return gotToken;
    },
  },
  computed: {
    showLoader() {
      return this.$store.state.showLoader;
      // return true;
    },
    isError() {
      return this.$store.state.isError;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue